import React, { useEffect, useState } from 'react'
import { Table, Button, Modal, Form } from 'react-bootstrap'
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa'
import { addUsers, getUsers, updateUser, deleteUser } from '../../Services/userService'
import toast from 'react-hot-toast'

const User = () => {
    const [users, setUsers] = useState([])
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [userName, setUserName] = useState("")
    const [password, setPassword] = useState("")
    const [role, setRole] = useState("user")
    const [show, setShow] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [selectedUserId, setSelectedUserId] = useState(null)
    const [loading, setLoading] = useState(false)

    //-----------------------------------
    // Reset Form
    //-----------------------------------

    const resetForm = () => {
        setFirstName("")
        setLastName("")
        setUserName("")
        setPassword("")
        setRole("user")
        setIsEdit(false)
        setSelectedUserId(null)
    }

    //-----------------------------------
    // Modal
    //-----------------------------------
    const handleClose = () => { setShow(false); resetForm() }
    const handleShow = () => { resetForm(); setShow(true) }

    //-----------------------------------
    // GET USERS
    //-----------------------------------

    const handleGetUserData = async () => {
        const response = await getUsers()
        if (response?.status === "success") setUsers(response?.data || [])
    }

    useEffect(() => { handleGetUserData() }, [])

    //-----------------------------------
    // EDIT USER (Prefill)
    //-----------------------------------

    const handleEdit = (user) => {
        setIsEdit(true)
        setSelectedUserId(user.id)
        setFirstName(user.firstName || "")
        setLastName(user.lastName || "")
        setUserName(user.userName || "")
        setRole(user.role || "user")
        setPassword("")
        setShow(true)
    }

    //-----------------------------------
    // ADD / UPDATE USER
    //-----------------------------------

    const handleSubmit = async () => {
        if (!firstName || !lastName || !userName || !role) {
            toast.error("Please fill all fields")
            return
        }

        setLoading(true)

        const body = { firstName, lastName, userName, password, role }

        let response
        if (isEdit) response = await updateUser(selectedUserId, body)
        else response = await addUsers(body)

        setLoading(false)

        if (response?.status === "success") {
            toast.success(response?.message)
            handleClose()
            handleGetUserData()
        } else toast.error(response?.message || "Something went wrong")
    }

    //-----------------------------------
    // DELETE USER
    //-----------------------------------

    const handleDelete = async (id) => {
        const response = await deleteUser(id);
        if (response?.status === "success") {
            toast.success(response?.message || "User deleted");
            handleGetUserData();
        } else toast.error(response?.message || "Delete failed");
    };

    //-----------------------------------

    return (
        <div className="p-4">

            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>Users</h4>
                <Button variant="primary" onClick={handleShow}><FaPlus /></Button>
            </div>

            {/* Table */}
            <Table bordered hover>
                <thead>
                    <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>User Name</th>
                        <th>Role</th> {/* added role column */}
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {users?.length > 0 ? (
                        users.map((user) => (
                            <tr key={user.id}>
                                <td>{user.firstName}</td>
                                <td>{user.lastName}</td>
                                <td>{user.userName}</td>
                                <td>{user.role || "user"}</td>
                                <td>
                                    <FaEdit
                                        className="me-3 text-primary"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleEdit(user)}
                                    />
                                    <FaTrash
                                        className="text-danger"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleDelete(user.id)}
                                    />
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5" className="text-center">No Users Found</td>
                        </tr>
                    )}
                </tbody>

            </Table>

            {/* Modal */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{isEdit ? 'Edit User' : 'Add User'}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-2">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                        </Form.Group>

                        <Form.Group className="mb-2">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control value={lastName} onChange={(e) => setLastName(e.target.value)} />
                        </Form.Group>

                        <Form.Group className="mb-2">
                            <Form.Label>User Name</Form.Label>
                            <Form.Control value={userName} onChange={(e) => setUserName(e.target.value)} />
                        </Form.Group>

                        <Form.Group className="mb-2">
                            <Form.Label>Role</Form.Label>
                            <Form.Select value={role} onChange={(e) => setRole(e.target.value)}>
                                <option value="user">User</option>
                                <option value="admin">Admin</option>
                            </Form.Select>
                        </Form.Group>

                        {!isEdit && (
                            <Form.Group>
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                            </Form.Group>
                        )}
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                    <Button variant="primary" onClick={handleSubmit} disabled={loading}>
                        {loading ? "Saving..." : isEdit ? "Update" : "Save"}
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    )
}

export default User
